/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @version 1.0.1
 * @since 1.0.0
 */
import produce from 'immer';

import { FETCH_FAILURE, FETCH_SUCCESS, SET_REQUEST_PARAMS, START_POLLING, STOP_POLLING } from './pollingConstants';
import { IPollingActionTypes, IPollingState } from './pollingTypes';

export const initialPollingState: IPollingState = {
    isPolling: false,
    requestParams: {
        duration: 5000,
        method: 'GET',
        path: '/',
    },
    response: null,
    error: '',
    result: false,
};

/**
 * Polling reducer - for long polling api methods
 * @param {IPollingState} state
 * @param {IPollingActionTypes} action
 * @returns {Produced<IPollingState, void>}
 */
const pollingReducer = (state: IPollingState = initialPollingState, action: IPollingActionTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case START_POLLING:
                draft.isPolling = true;
                break;
            case STOP_POLLING:
                draft.isPolling = false;
                break;
            case FETCH_SUCCESS:
                draft.response = action.payload;
                draft.result = true;
                break;
            case FETCH_FAILURE:
                draft.error = action.payload;
                draft.result = false;
                break;
            case SET_REQUEST_PARAMS:
                draft.requestParams = { ...draft.requestParams, ...action.payload };
                break;
            default:
                break;
        }
    });

export default pollingReducer;
